<p-dialog [(visible)]="showDialog" [modal]="true" [baseZIndex]="10000" [draggable]="false" [resizable]="false"
    (onHide)="hideTheDialog()" [style]="{'max-width': '90vw'}">

    <ng-template pTemplate="header">
        <div [style]="{width: '100%'}" class="d-flex justify-content-center">
            @if (contentType === 'selectSubscription') {
                <h3><b>{{ 'integration_apps_dialog_header_subscriptions' | i18next }}</b></h3>
            }
            @if (contentType === 'showResources') {
                @if (!preselectedSubscription) {
                    <app-content-header [historyBack]="false" (backEvent)="onBack('showResources')"
                        class="mr-auto"></app-content-header>
                }
                <h3 class="{{ preselectedSubscription ? '' : 'mr-auto' }}"><b>{{
                    (isUpgrade ? 'integration_apps_dialog_header_upgrade_resources' : 
                    'integration_apps_dialog_header_resources') | i18next }}</b></h3>
            }
            @if (contentType === 'showApiKeySecrets') {
                <app-content-header [historyBack]="false" (backEvent)="onBack('showApiKeySecrets')"
                    class="mr-auto"></app-content-header>
                <h3 class="mr-auto"><b>{{ (isUpgrade ? 'integration_apps_dialog_header_upgrade_permission_secrets' :
                    'integration_apps_dialog_header_permission_secrets') | i18next }}</b></h3>
            }
            @if (contentType === 'confirmUninstallation') {
                <h3><b>{{ 'integration_apps_dialog_header_confirm_uninstallation' | i18next }}</b></h3>
            }
        </div>
    </ng-template>

    @if (contentType === 'selectSubscription') {
        @if (subscriptionsInitial.length !== 0) {
            <div class="d-flex flex-md-row justify-content-end">
                <app-filter (searchFilterChanged)="filter($event)"
                    [placeholder]="'integration_apps_search_subscriptions_placeholder' | i18next"></app-filter>
            </div>
        }

        <div class="row align-items-stretch mt-2" [style]="{ 'min-width': '50vw'}">
            @if (subscriptionsInitial.length !== 0) {
                @for (lic of subscriptionsToDisplay; track lic.appliance_id) {
                    <app-subscription-card class="col-12 col-md-6 mb-3" [withBorder]="true" [subscription]="lic"
                        [detaillist]="false">
                        <button class="btn btn-outline-primary" (click)="subSelected(lic)">{{ 'app_select' | i18next }}</button>
                    </app-subscription-card>
                }
            } @else {
                <app-no-content-message class="mb-5" t="no_subscription_to_install_this_integration_app"></app-no-content-message>
            }
        </div>
    }

    @if (contentType === 'showResources' && integrationApp) {
        <app-integration-apps-resources-card [integrationApp]="integrationApp" [needsSecret]="showSecretScreen() && !isRetry" [isUpgrade]="isUpgrade"
            (onResourceImportConfirmed)="onResourceImportConfirmed()" (cancel)="hideTheDialog()"></app-integration-apps-resources-card>
    }

    @if (contentType === 'showApiKeySecrets') {
        <app-integration-apps-permission-secrets [apiPermissions]="integrationApp.apiPermissions" [isUpgrade]="isUpgrade"
            [previousApiPermissions]="previousApiPermissions" (cancel)="hideTheDialog()" (emitSecrets)="hashPermissionSecrets($event)">
        </app-integration-apps-permission-secrets>
    }

    @if (contentType === 'confirmUninstallation') {
        <div class="d-flex flex-column">
            <span class="m-3 mb-5" style="font-size: larger;">{{ 'integration_apps_uninstall_info_text' | i18next }}</span>
            <div class="align-self-end">
                <button class="btn btn-link mr-2" (click)="hideTheDialog()">{{ 'app_cancel' | i18next }}</button>
                <button class="btn btn-outline-primary" type="button" (click)="confirmUninstall()">{{
                    'integration_apps_uninstall_hint' | i18next }}</button>
            </div>
        </div>
    }

</p-dialog>